module.exports = __webpack_public_path__ + "static/img/idtype_card.866f7ce1.png";